import Navbar from "@/components/Navbar";
import { Link } from "react-router-dom";
import { ArrowLeft, Warning } from "@phosphor-icons/react";

export default function Terms() {
  return (
    <div className="min-h-screen bg-[#050505]">
      <Navbar />
      <article className="max-w-3xl mx-auto px-4 sm:px-6 py-10 text-white/80 leading-relaxed">
        <Link to="/" className="inline-flex items-center gap-2 text-white/60 hover:text-white text-sm mb-6">
          <ArrowLeft size={16} /> Volver al inicio
        </Link>

        <p className="text-sm uppercase tracking-widest text-[#FFB800] mb-3">Documento legal</p>
        <h1 className="font-display text-4xl sm:text-5xl font-black tracking-tighter mb-2">Términos del Servicio</h1>
        <p className="text-white/40 text-sm mb-10">Última actualización: febrero de 2026</p>

        <div className="rounded-2xl bg-[#FFB800]/5 border border-[#FFB800]/20 p-5 mb-8 flex items-start gap-3">
          <Warning size={22} weight="fill" className="text-[#FFB800] shrink-0 mt-0.5" />
          <p className="text-sm text-white/80">
            Lea con atención este documento. Al usar Tu MusiKa usted acepta íntegramente los términos aquí descritos.
          </p>
        </div>

        <Section title="1. Identidad de la Empresa">
          <p>
            <strong className="text-white">Marketing de Inteligencia Artificial S. de R.L. de C.V.</strong> (en adelante &ldquo;la Empresa&rdquo;, &ldquo;nosotros&rdquo; o &ldquo;Tu MusiKa&rdquo;), con domicilio en Av. Américas 1545, Colonia Providencia, Guadalajara, Jalisco, México, es la titular y operadora de la plataforma <strong className="text-white">tumusika.com</strong> y todos sus servicios derivados.
          </p>
        </Section>

        <Section title="2. Objeto del servicio">
          <p>
            Tu MusiKa es una plataforma tecnológica que pone a disposición del usuario herramientas de inteligencia artificial para crear canciones personalizadas con fines de <strong className="text-white">parodia, entretenimiento, regalo personal o uso doméstico</strong>, a partir de una historia, dedicatoria o texto libre que el propio usuario proporciona.
          </p>
        </Section>

        <Section title="3. Cuenta de usuario">
          <p>
            Para utilizar el servicio se requiere crear una cuenta proporcionando un número de teléfono celular válido y una contraseña. El usuario es el único responsable de mantener la confidencialidad de sus credenciales y de toda actividad realizada con su cuenta.
          </p>
          <p className="mt-2">
            La Empresa se reserva el derecho de suspender o cancelar cuentas que infrinjan estos términos, sin necesidad de notificación previa.
          </p>
        </Section>

        <Section title="4. Paquetes y precios">
          <p>Los paquetes ofrecidos son:</p>
          <ul className="list-disc pl-6 space-y-1.5 mt-2">
            <li><strong className="text-white">SINGLE</strong> — $49 MXN, 1 canción.</li>
            <li><strong className="text-white">EXTENDED PLAY</strong> — $120 MXN, 3 canciones.</li>
            <li><strong className="text-white">ALBUM</strong> — $249 MXN, 7 canciones.</li>
          </ul>
          <p className="mt-3">
            Los precios están expresados en pesos mexicanos (MXN) e incluyen los impuestos aplicables. La Empresa puede modificar los precios futuros sin afectar compras ya realizadas.
          </p>
        </Section>

        <Section title="5. Medios de pago">
          <p>
            Aceptamos pagos con tarjeta de débito o crédito a través de Stripe y transferencia bancaria SPEI a la cuenta BBVA del beneficiario <strong className="text-white">Ricardo Zermeño Mejía</strong>. Los pagos por transferencia se validan manualmente por el administrador en un plazo máximo de 24 horas hábiles después de recibido el comprobante.
          </p>
        </Section>

        <Section title="6. Política de reembolsos">
          <p>
            Debido a la naturaleza digital e inmediata del servicio (consumo de créditos de IA al generar la canción), <strong className="text-white">no se otorgan reembolsos una vez que el usuario ha generado la letra de su primera canción</strong>. Si experimenta problemas técnicos que impidan recibir su canción, contáctenos al WhatsApp <span className="font-mono text-white">+52 33 4280 2102</span> y resolveremos el caso en menos de 48 horas.
          </p>
        </Section>

        <Section title="7. Derechos de autor sobre las canciones creadas">
          <p>
            <strong className="text-white">La canción creada (letra, audio y portada) pertenece al usuario que la generó.</strong> El usuario adquiere los derechos patrimoniales sobre la obra resultante y puede utilizarla libremente para fines personales, parodia, regalo o entretenimiento, así como compartirla en redes sociales.
          </p>
          <p className="mt-3">
            La Empresa renuncia a cualquier reclamo de titularidad sobre las canciones generadas por los usuarios y se obliga a no comercializar ni utilizar dichas obras sin el consentimiento expreso del usuario.
          </p>
        </Section>

        <Section title="7.bis Programa de regalías para creadores (uso comercial opcional)">
          <div className="rounded-2xl bg-[#B4F34A]/5 border border-[#B4F34A]/20 p-5 mb-3">
            <p className="text-white">
              <strong>Esquema 60 / 40:</strong> el usuario puede autorizar expresamente, desde el panel de su canción, la inclusión de ésta en el repertorio comercial que la Empresa vende a restaurantes, bares, cafeterías y comercios suscritos al servicio Tu MusiKa Negocios.
            </p>
          </div>
          <ol className="list-decimal pl-6 space-y-2 mt-3">
            <li>La autorización es <strong className="text-white">voluntaria, individual por canción y revocable</strong> en cualquier momento por el creador.</li>
            <li>Cada mes la Empresa selecciona un <strong className="text-white">TOP de canciones</strong> con base en reproducciones, votos y criterios técnicos de calidad. Sólo las canciones que entran al TOP forman parte del repertorio comercial vigente.</li>
            <li>Del total recaudado por las suscripciones de comercios en cada periodo de pago, <strong className="text-white">el 60% se destina íntegramente al fondo de regalías de creadores</strong> y el 40% a la operación, infraestructura, fiscalidad y administración de la Empresa.</li>
            <li>El 60% se <strong className="text-white">prorratea entre todas las canciones vigentes</strong> del repertorio comercial en función de su número de reproducciones efectivas en los establecimientos del periodo correspondiente. Un creador puede tener varias canciones vigentes simultáneamente.</li>
            <li><strong className="text-white">Cada 3 meses</strong> se renueva el repertorio: las canciones más reproducidas permanecen y las menos reproducidas son sustituidas por nuevos ingresos del TOP.</li>
            <li>El creador elige la frecuencia de pago de sus regalías: <strong className="text-white">trimestral, semestral o anual</strong>, mediante depósito a la cuenta bancaria que registró al autorizar.</li>
            <li>Para autorizar el uso comercial, el creador debe ser <strong className="text-white">mayor de edad</strong> y proporcionar nombre completo, domicilio y datos bancarios bajo protesta de decir verdad. La Empresa puede solicitar identificación oficial antes de un depósito relevante.</li>
            <li>La Empresa publica trimestralmente un reporte agregado de regalías y se obliga a entregar al creador un desglose individual de los pagos recibidos.</li>
            <li>El creador conserva en todo momento la titularidad de su canción; la autorización es una <strong className="text-white">licencia no exclusiva de reproducción pública</strong> en establecimientos suscritos a Tu MusiKa Negocios.</li>
          </ol>
        </Section>

        <Section title="8. Responsabilidad del usuario — violación de derechos de terceros">
          <div className="rounded-2xl bg-[#FF4B00]/5 border border-[#FF4B00]/20 p-5 mb-3">
            <p className="text-white">
              <strong>Cláusula esencial:</strong> en caso de que la canción generada por el usuario contenga, replique, parodie o se inspire en obras protegidas de terceros (artistas, intérpretes, compositores, autores) y esto derive en una reclamación, demanda o procedimiento legal por violación de derechos de autor, derechos conexos, derechos de imagen, difamación o cualquier otro derecho de terceros, <strong>el usuario es el único y exclusivo responsable</strong>.
            </p>
          </div>
          <p>
            La Empresa actúa únicamente como un <strong className="text-white">medio tecnológico</strong> que facilita la creación de canciones con fines de parodia y entretenimiento. La Empresa no controla, supervisa ni edita el contenido de las historias proporcionadas por los usuarios ni el de las canciones resultantes.
          </p>
          <p className="mt-3">
            El usuario se obliga a sacar en paz y a salvo a Marketing de Inteligencia Artificial S. de R.L. de C.V., a sus accionistas, directivos, empleados y proveedores tecnológicos, de cualquier reclamación, indemnización, gasto o costo (incluidos honorarios de abogados) derivado del uso que haga de las canciones generadas en la plataforma.
          </p>
        </Section>

        <Section title="9. Uso prohibido">
          <p>El usuario se obliga a NO utilizar la plataforma para:</p>
          <ul className="list-disc pl-6 space-y-1.5 mt-2">
            <li>Generar contenido que apologice, promueva o glorifique la violencia, el terrorismo, la trata de personas o cualquier actividad ilegal.</li>
            <li>Generar contenido con intención difamatoria, calumniosa o injuriosa contra una persona identificable.</li>
            <li>Suplantar la identidad de un artista, intérprete o autor para hacer pasar la canción como obra suya.</li>
            <li>Reproducir literalmente letras protegidas de terceros (la inspiración en un estilo es permitida; la copia literal no).</li>
            <li>Vulnerar los derechos sexuales, de imagen o privacidad de menores de edad.</li>
            <li>Realizar ingeniería inversa, scraping masivo o ataques al servicio.</li>
          </ul>
          <p className="mt-3">
            La violación de cualquiera de estas reglas conllevará la cancelación inmediata de la cuenta sin derecho a reembolso, así como la denuncia ante las autoridades cuando proceda.
          </p>
        </Section>

        <Section title="10. Propiedad intelectual de la plataforma">
          <p>
            Todo el software, código fuente, diseño, logos, nombre comercial &ldquo;Tu MusiKa&rdquo; y cualquier elemento gráfico de la plataforma son propiedad exclusiva de Marketing de Inteligencia Artificial S. de R.L. de C.V. El usuario no adquiere ningún derecho sobre estos elementos por el solo hecho de utilizar el servicio.
          </p>
        </Section>

        <Section title="11. Limitación de responsabilidad">
          <p>
            La plataforma se ofrece &ldquo;tal cual&rdquo; sin garantías implícitas. La Empresa no será responsable de daños indirectos, lucro cesante, pérdida de datos o cualquier perjuicio derivado de la imposibilidad de usar el servicio. La responsabilidad máxima de la Empresa frente al usuario se limita al monto efectivamente pagado por el paquete adquirido.
          </p>
        </Section>

        <Section title="12. Modificaciones a los términos">
          <p>
            La Empresa puede modificar estos términos en cualquier momento. Las modificaciones surten efecto al publicarse en esta misma URL con su fecha de actualización. El uso continuado del servicio implica aceptación de los términos vigentes.
          </p>
        </Section>

        <Section title="13. Jurisdicción aplicable">
          <p>
            Estos términos se rigen por las leyes de los Estados Unidos Mexicanos. Para cualquier controversia, las partes se someten expresamente a la jurisdicción de los tribunales competentes de la ciudad de <strong className="text-white">Guadalajara, Jalisco</strong>, renunciando a cualquier otro fuero que pudiera corresponderles.
          </p>
        </Section>

        <Section title="14. Contacto">
          <p>
            Para cualquier duda, aclaración o ejercicio de derechos relacionados con estos términos, escríbanos al WhatsApp <span className="font-mono text-white">+52 33 4280 2102</span>.
          </p>
        </Section>

        <div className="mt-10 pt-6 border-t border-white/10 text-sm text-white/40">
          <p>Marketing de Inteligencia Artificial S. de R.L. de C.V. · Av. Américas 1545, Col. Providencia, Guadalajara, Jal., México.</p>
        </div>
      </article>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <section className="mb-8">
      <h2 className="font-display text-xl sm:text-2xl font-bold text-white mb-3">{title}</h2>
      <div className="space-y-2">{children}</div>
    </section>
  );
}
